import { Injectable, signal } from "@angular/core";

@Injectable()
export class HomeExternalNavState {
	private obs: IntersectionObserver | null = null;

	readonly activeFragment = signal<string | null>(null);

	startHomeSectionsObserver(): void {
		if (typeof document === "undefined") {
			return;
		}
		this.stop();
		const fragments = ["services", "how-it-works", "faqs"];
		this.obs = new IntersectionObserver(
			(entries) => {
				const visible = entries.filter((e) => e.isIntersecting).sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
				if (visible) {
					this.activeFragment.set(visible.target.id);
				}
			},
			{
				rootMargin: "-40% 0px -55% 0px",
				threshold: [0, 0.25, 0.5, 0.75, 1],
			},
		);
		for (const id of fragments) {
			const el = document.getElementById(id);
			if (el) {
				this.obs.observe(el);
			}
		}
	}

	stop(): void {
		this.obs?.disconnect();
		this.obs = null;
		this.activeFragment.set(null);
	}
}
